import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import { useTheme } from "@mui/material/styles";
import { blue } from "./constants";



const Avatar: React.FC<{

}> = () => {

    return (
        <Box
            id='side-header'
            sx={{
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            <Box
                id='avatar'
                sx={{
                    lineHeight: 0,
                    overflow: 'hidden',
                    height: 160,
                    width: 160,
                    borderRadius: 80,
                }}
            >
                <Box
                    component='img'
                    src={process.env.PUBLIC_URL + '/avatar.jpg'}
                    sx={{
                        height: 200,
                        marginLeft: '-20px',
                        marginTop: '-5px',
                    }}
                />
            </Box>
        </Box>
    )
}

const NameTitle: React.FC<{

}> = () => {

    const theme = useTheme();

    return (
        <Box
            id='main-header'
            sx={{
                display: 'flex',
                flexDirection: 'column',
                mt: 1,
                ml: 4,
                mb: 3,
                letterSpacing: 2,
            }}
        >
            <Box component='h1' sx={{ m: 0, fontSize: '3em' }}>
                <span style={{ marginRight: 10, color: blue }}>Mikalai "Nick"</span>
                <span style={{ fontWeight: 'normal' }}>Miatlitski</span>
            </Box>
            <Box component='h3' sx={{ m: 0, fontWeight: 'normal', lineHeight: '1em', color: blue }}>
                Senior Software Engineer | Java • Spring Boot • React • SaaS Platforms
            </Box>
        </Box>
    )
}

export { Avatar, NameTitle };